export const NOTES_LIST_REQUEST = "NOTES_LIST_REQUEST";
export const NOTES_LIST_SUCCESS = "NOTES_LIST_SUCCESS";
export const NOTES_LIST_FAIL = "NOTES_LIST_FAIL";

export const NOTES_CREATE_REQUEST = "NOTES_CREATE_REQUEST";
export const NOTES_CREATE_SUCCESS = "NOTES_CREATE_SUCCESS";
export const NOTES_CREATE_FAIL = "NOTES_CREATE_FAIL";

export const NOTES_UPDATE_REQUEST = "NOTES_UPDATE_REQUEST";
export const NOTES_UPDATE_SUCCESS = "NOTES_UPDATE_SUCCESS";
export const NOTES_UPDATE_FAIL = "NOTES_UPDATE_FAIL";

export const NOTES_DELETE_REQUEST = "NOTES_DELETE_REQUEST";
export const NOTES_DELETE_SUCCESS = "NOTES_DELETE_SUCCESS";
export const NOTES_DELETE_FAIL = "NOTES_DELETE_FAIL";
